import TableToolbar from '@rio-cloud/rio-uikit/TableToolbar';
import { useAppSelector } from '../../../../../configuration/setup/hooks';
import { getSelectedCategory } from '../../../reducers/transportAssignmentsSlice';
import { TableColumnSettings } from '../../../sharedComponents/table/TableColumnSettings';
import { StatusCount } from '../../transportAssignment.types';
import { CategoriesSelection } from './CategoriesSelection';
import { TableCategory } from '../../tableCategory.types';
import { TransportAssignmentExport } from './TransportAssignmentExport';
import { TransportAssignmentFilterModal } from './TransportAssignmentFilterModal';
import { TransportAssignmentStatusFilter } from './TransportAssignmentStatusFilter';
import { TransportOrderToolbarSearch } from './TransportOrderToolbarSearch';
import { TransportOrderBulkUpdate } from '../../bulkUpdate/TransportOrderBulkUpdate';
import { TableViewOptions } from '../../../sharedComponents/TableViewOptions';

type TransportAssignmentTableToolbarProps = {
    readonly assignmentsPerStatus: StatusCount | undefined;
};

export const TransportAssignmentsTableToolbar = (props: TransportAssignmentTableToolbarProps) => {
    const activeCategory = useAppSelector(getSelectedCategory);

    return (
        <TableToolbar>
            <div className="table-toolbar-container">
                <div className="table-toolbar-group-left">
                    <div className="table-toolbar-column">
                        <div className="btn-toolbar table-btn-toolbar">
                            <CategoriesSelection assignmentsPerStatus={props.assignmentsPerStatus} />
                        </div>
                    </div>
                </div>
                <div className="table-toolbar-group-right">
                    <div className="table-toolbar-column table-toolbar-column-spacer">
                        <TransportOrderBulkUpdate />
                    </div>
                    {activeCategory === TableCategory.INBOX && (
                        <div className="table-toolbar-column min-width-300">
                            <TransportAssignmentStatusFilter />
                        </div>
                    )}
                    <div className="table-toolbar-column">
                        <TransportAssignmentFilterModal />
                    </div>
                    <div className="table-toolbar-column">
                        <TransportOrderToolbarSearch />
                    </div>
                    <div className="table-toolbar-column">
                        <TransportAssignmentExport />
                    </div>
                    <div className="table-toolbar-column">
                        <TableViewOptions />
                    </div>
                    <div className="table-toolbar-column">
                        <TableColumnSettings />
                    </div>
                </div>
            </div>
        </TableToolbar>
    );
};
